import { ReactNode } from "react";
import cn from "clsx";

export interface EmptyStateProps {
  /** Icon-Element (z. B. <Inbox className="w-6 h-6" />). */
  icon?: ReactNode;
  title: ReactNode;
  hint?: ReactNode;
  /** Optionale primäre Aktion (typ. ein <Button>). Nie Sackgasse. */
  action?: ReactNode;
  className?: string;
}

/** Leerzustand: Icon + Titel + 1 Satz + optionale Aktion (Spec §3). */
export function EmptyState({ icon, title, hint, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center text-center py-12 px-6",
        className
      )}
    >
      {icon && (
        <div className="mb-3 flex items-center justify-center w-12 h-12 rounded-full bg-surface-3 text-text-3">
          {icon}
        </div>
      )}
      <div className="text-sm font-medium text-text">{title}</div>
      {hint && <div className="mt-1 text-sm text-text-2 max-w-sm">{hint}</div>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

export default EmptyState;
